/**
 * @generated SignedSource<<5de349b22ac14effe9ef5195db4d321e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useShippingAndReturns_user$data = {
  readonly profile: {
    readonly email: string | null;
  } | null;
  readonly " $fragmentType": "useShippingAndReturns_user";
};
export type useShippingAndReturns_user$key = {
  readonly " $data"?: useShippingAndReturns_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShippingAndReturns_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShippingAndReturns_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "c546f5bd0259715dc79c65e5dc8c5aad";

export default node;
